import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

// Sample Data
const data = [
  { name: "Category A", value: 0 },
  { name: "Category B", value: 0 },
  { name: "Category C", value: 0 },
  { name: "Category D", value: 200 },
];

// Colors for the Pie Chart
const COLORS = [
  "#0088FE", // Blue
  "#00C49F", // Green

  "#FF8042", // Orange
  "#8A2BE2", // BlueViolet
  "#FF69B4", // HotPink
  "#7B68EE", // MediumSlateBlue
  "#32CD32", // LimeGreen

  "#DC143C", // Crimson
  "#20B2AA", // LightSeaGreen
  "#FF4500", // OrangeRed
];

// Custom Label Component
const renderCustomLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) / 2;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={14}
    >
      {value}
    </text>
  );
};

const CustomPieChart = (props) => {
  const { data } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Pie Chart */}
      <PieChart width={500} height={400}>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={120}
          innerRadius={60}
          fill="#8884d8"
          label={renderCustomLabel} // Use custom label renderer
          labelLine={false} // Disable lines
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>

      {/* Legend */}
      <div style={{ marginLeft: "0px", textAlign: "left" }}>
        <h3>Legend</h3>
        {data.map((entry, index) => (
          <div
            key={`legend-item-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: COLORS[index % COLORS.length],
                marginRight: "10px",
              }}
            ></div>
            <span>
              {entry.name}: {entry.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomPieChart;
